import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();
export const getHubSpotForms = ({ params }: { params: Record<string, any> }) => {
  return axios({
    method: "GET",
    url: "/hubspot/forms",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getHubSpotFormSubmissions = (formGuid: string, limit: number = 10, after?: string | null) => {
  return axios({
    method: "GET",
    url: `/hubspot/forms/${formGuid}/submissions`,
    params: {
      limit,
      after,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const disconnectHubSpot = () => {
  return axios({
    method: "POST",
    url: "/hubspot/disconnect",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};